export default __webpack_public_path__ + "static/media/pic1.dbbe3f7c.png";